/*
 * @Author: Han
 * @Date: 2021-12-02 13:22:20
 * @LastEditors: Han
 * @LastEditTime: 2022-03-22 17:18:00
 * @FilePath: \yooacs\console\src\http\moudules\courseManagement.js
 */
import axios from '../axios'

// 查看学校列表
export const getSchoolList = (data) => {
  return axios({
    url: '/school/pageForOrgan',
    method: 'GET',
    data
  })
}
// 获取课程列表
export const getCourseList = (data) => {
  return axios({
    url: '/course/select',
    method: 'GET',
    data
  })
}
// 获取课程分类
export const getCourseType = (data) => {
  return axios({
    url: '/course/type/select',
    method: 'GET',
    data
  })
}
// 获取课程列表
export const getCourseLists = (data) => {
  return axios({
    url: '/course/selectTermCourse',
    method: 'GET',
    data
  })
}
// 新增教课程类型
export const addCourseType = (data) => {
  return axios({
    url: '/course/type/save',
    method: 'POST',
    data
  })
}
// 修改课程类型
export const updateCourseType = (data) => {
  return axios({
    url: '/course/type/update',
    method: 'POST',
    data
  })
}
// 删除课程类型
export const delCourseType = (data) => {
  return axios({
    url: '/course/type/delete',
    method: 'POST',
    data
  })
}
// 获取课程报名状态
export const getCourseBmStatus = () => {
  return axios({
    url: '/course/setting/detail',
    method: 'GET'
  })
}

// 课程报名设置
export const courseTypeEnroll = (data) => {
  return axios({
    url: '/course/setting/enroll',
    method: 'POST',
    data
  })
}
// 设置课程须知
export const setCourseTypeTips = (data) => {
  return axios({
    url: '/course/setting/notice',
    method: 'POST',
    data
  })
}
// 新增课程
export const addCourse = (data) => {
  return axios({
    url: '/course/save',
    method: 'POST',
    data
  })
}
// 新增课程
export const courseDetail = (data) => {
  return axios({
    url: '/course/detail',
    method: 'GET',
    data
  })
}
// 课程修改
export const updateCourse = (data) => {
  return axios({
    url: '/course/update',
    method: 'POST',
    data
  })
}
// 课程删除
export const delCourse = (data) => {
  return axios({
    url: '/course/delete',
    method: 'POST',
    data
  })
}




// 课程班列表
export const getCourseClassList = (data) => {
  return axios({
    url: '/con/course/class/getCourseClassList',
    method: 'GET',
    data
  })
}
// 添加课程班
export const addCourseClass = (data) => {
  return axios({
    url: '/con/course/class/addCourseClass',
    method: 'GET',
    data
  })
}
// 修改课程班
export const editCourseClass = (data) => {
  return axios({
    url: '/con/course/class/updateCourseClass',
    method: 'GET',
    data
  })
}
// 删除课程班
export const delCourseClass = (data) => {
  return axios({
    url: '/con/course/class/removeCourseClass',
    method: 'GET',
    data
  })
}
// 课程班名称重复判断
export const checkCourseClassName = (data) => {
  return axios({
    url: '/con/course/class/checkCourseClassName',
    method: 'GET',
    data
  })
}
// 判断课程分类名称是否重复
export const checkBaseClassName = (data) => {
  return axios({
    url: '/course/type/check_existed',
    data
  })
}
//局端-新增机构课程-列表
export const educationThirdPartyCourse = (data) => {
  return axios({
    url: '/course/for_education/third_party_course',
    method: 'GET',
    data
  })
}



// 判断是否通过认证
export const getCheckAuth = (data) => {
  return axios({
    url: '/third_party/check_auth',
    data
  })
}
//局端-新增机构课程-列表
export const educationThirdPartyCourseDetail = (data) => {
  return axios({
    url: '/course/for_education/third_party_course_detail',
    method: 'GET',
    data
  })
}

//校端-新增机构课程-列表
export const schoolThirdPartyCourse = (data) => {
  return axios({
    url: '/course/for_school/third_party_course',
    method: 'GET',
    data
  })
}

//校端-新增机构课程-列表
export const schoolThirdPartyCourseDetail = (data) => {
  return axios({
    url: '/course/for_school/third_party_course_detail',
    method: 'GET',
    data
  })
}

//当前教育局下的所有学校
export const schoolCurrentEdu = (data) => {
  return axios({
    url: '/school/list/by_current_edu',
    method: 'GET',
    data
  })
}

//获取教育局下所有已经通过审核的第三方机构
export const thirdPartyCurrentEdu = (data) => {
  return axios({
    url: '/third_party/list/by_current_edu',
    method: 'GET',
    data
  })
}



//学校-课程管理-机构课程-接入/取消接入
export const schooThirdAccess = (data) => {
  return axios({
    url: '/course/for_school/third_party_course/access',
    method: 'POST',
    data
  })
}

// 上传课程
export const uploadClassStatus = (data) => {
  return axios({
    url: '/course/third_party/upload',
    method: 'POST',
    data
  })
}

// 获取上传课程列表
export const getUploadClassList = (data) => {
  return axios({
    url: '/course/third_party/course_list',
    method: 'GET',
    data
  })
}

// 获取教师列表
export const getTeacherList = (data) => {
  return axios({
    url: '/third_party/teacher_list',
    method: 'GET',
    data
  })
}

// 第三方机构 审核完成列表

export const getThirdCheckList = (data) => {
  return axios({
    url: '/course/third_party/pass_count',
    method: 'GET',
    data
  })
}


// 第三方机构-课程管理-审核完成课程列表-查看详情页面
export const getThirdCheckListInfo = (data) => {
  return axios({
    url: '/course/third_party/pass_detail',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/courseManagement.js